import type { SurveyResponse } from "@qendo/survey";
import Data from "~/util/data";

export class QldSurveyData extends Data implements SurveyResponse {
    constructor(public in_queensland: boolean | null = null) {
        super();
    }

    public valid(): boolean {
        return this.in_queensland !== null;
    }
}
